import { render, staticRenderFns } from "./ContractsView.vue?vue&type=template&id=343ebcd5&lang=pug&"
import script from "./ContractsView.vue?vue&type=script&lang=ts&"
export * from "./ContractsView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports